import ConfigurationRightPanel from "./configurationRightPanel";
export default ConfigurationRightPanel;
